import type { VegaTablePagination } from '@globalpayments/vega/dist/types/components/vega-table/interface';
import { ALL_HORIZON_REGIONS, ALL_TRIGGERED_BY } from '../../types/horizonOptOutTracker';
import type { HorizonOptOutType, HorizonRegion } from '../../types/horizonOptOutTracker';

export const chipColors: Record<
  HorizonRegion | HorizonOptOutType,
  {
    bgColor:
      | 'bg-accent1-primary'
      | 'bg-accent3-primary'
      | 'bg-accent8-primary'
      | 'bg-action'
      | 'bg-status-warning';
    textColor: 'text-black' | 'text-white';
  }
> = {
  'Global Payments': { bgColor: 'bg-action', textColor: 'text-white' },
  UK: { bgColor: 'bg-accent3-primary', textColor: 'text-black' },
  US: { bgColor: 'bg-accent1-primary', textColor: 'text-black' },
  Worth: { bgColor: 'bg-accent8-primary', textColor: 'text-white' },
  'Worth unavailable': { bgColor: 'bg-status-warning', textColor: 'text-black' },
};

export const horizonRegionOptions = [
  { id: ALL_HORIZON_REGIONS, displayName: 'All' },
  { id: 'US', displayName: 'US' },
  { id: 'UK', displayName: 'UK' },
] as const;

export const triggeredByOptions = [
  { id: ALL_TRIGGERED_BY, displayName: 'All' },
  { id: 'Worth', displayName: 'Worth' },
  { id: 'Non-Worth', displayName: 'Non-Worth' },
] as const;

/**
 * Pagination layout for the tracker table.
 *
 * `vega-pagination` has no disabled state for the Go To field, so a single-page result drops the
 * extension altogether rather than offering a page that cannot be reached.
 */
export const tablePagination = {
  extensions: [
    ['currentPageLabel', 'pageSizeSelector'],
    ['pageSelector', 'goTo'],
  ],
  pageSize: 10,
  pageSizeSelectorOptions: [10, 25, 50],
  position: 'bottom-right',
} satisfies VegaTablePagination;

export const singlePageExtensions = [
  ['currentPageLabel', 'pageSizeSelector'],
  ['pageSelector'],
] satisfies VegaTablePagination['extensions'];
